import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import LibDayPicker, { DateUtils } from 'react-day-picker';

class DayPicker extends Component {
  componentDidMount() {
    if (this.props.maxRange === 1) {
      this.props.onPeriodSelected({
        startDate: this.props.startDate,
        endDate: this.props.startDate,
      });
    }
  }

  dateSelected = (day, { disabled }) => {
    if (disabled) return;
    if (this.props.predefinedRange) {
      this.props.onPeriodSelected(this.props.predefinedRange(day));
    } else {
      this.props.onPeriodSelected({ startDate: day, endDate: day });
    }
  };

  rangeSelected = (day, { disabled }) => {
    if (disabled) return;
    const range = DateUtils
      .addDayToRange(day, { from: this.props.startDate, to: this.props.endDate });
    if (range.from !== null) {
      this.props.onPeriodSelected({ startDate: range.from, endDate: range.to });
    }
  };

  render() {
    const { startDate, endDate, maxRange } = this.props;
    const adjustedMaxRange = maxRange - 1;
    const today = new Date();
    const maxRangeAfterStartDate = moment(startDate).add(adjustedMaxRange, 'days').toDate();
    return maxRange === 1 ? (
      <div>
        <LibDayPicker
          firstDayOfWeek={1}
          initialMonth={startDate || today}
          modifiers={{ highlighted: startDate }}
          numberOfMonths={2}
          onDayClick={this.dateSelected}
          selectedDays={startDate}
        />
      </div>
    ) : (
      <div>
        <LibDayPicker
          disabledDays={{
            after: today > maxRangeAfterStartDate ? maxRangeAfterStartDate : '',
            before: endDate && moment(endDate).subtract(adjustedMaxRange, 'days').toDate(),
          }}
          firstDayOfWeek={1}
          initialMonth={endDate || today}
          modifiers={{ start: startDate, end: endDate }}
          numberOfMonths={2}
          onDayClick={this.rangeSelected}
          selectedDays={[startDate, { from: startDate, to: endDate }]}
        />
      </div>
    );
  }
}

export default DayPicker;

DayPicker.propTypes = {
  onPeriodSelected: PropTypes.func,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  maxRange: PropTypes.number,
  predefinedRange: PropTypes.func,
};
